import { render, staticRenderFns } from "./UserPhone.vue?vue&type=template&id=3fd93d74&scoped=true&"
import script from "./UserPhone.vue?vue&type=script&lang=js&"
export * from "./UserPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd93d74",
  null
  
)

export default component.exports